import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
// import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import Button from "components/controls/Button";
import { basicAPI, client } from "api";
import { setGlobalState } from "Global";

export default function CustomLogin() {
  const [searchParams] = useSearchParams();

  // const isAuthenticated = useIsAuthenticated();

  const navigation = useNavigate();

  // const { instance } = useMsal();

  // const initializeSignIn = () => {
  //   instance.loginRedirect({
  //     scopes:['user.read']
  //   });
  // };

  useEffect(() => {
    basicAPI
      .loginCallback(searchParams.get("code"))
      .then((res) => {
        const accessToken = res.data.access_token || res.data.token;
        setGlobalState("userDetails", { ...res.data, access_token: accessToken });
        client.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
        navigation("/");
      })
      .catch((error) => {});
  }, []);

  return (
    <>
      <Button>Signin</Button>
    </>
  );
}
